module.exports = __webpack_public_path__ + "static/media/lungdis_help2550.95b8c012.png";